import { DxPieChartModule } from "devextreme-angular";

export const DevExtremeModules = [
    DxPieChartModule
]